import dayjs from "dayjs"

export const getTimeframe = (fromDays: number) => {
  const from = dayjs().subtract(fromDays, `days`).valueOf()
  const to = dayjs().add(1, `day`).valueOf()
  return { from, to }
}
